import { render, staticRenderFns } from "./ContinueConfig.vue?vue&type=template&id=8bd9f9a2&"
import script from "./ContinueConfig.vue?vue&type=script&lang=js&"
export * from "./ContinueConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ContinueConfig.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bd9f9a2')) {
      api.createRecord('8bd9f9a2', component.options)
    } else {
      api.reload('8bd9f9a2', component.options)
    }
    module.hot.accept("./ContinueConfig.vue?vue&type=template&id=8bd9f9a2&", function () {
      api.rerender('8bd9f9a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/ContinueConfig.vue"
export default component.exports